import React from 'react';
import {
    Alert,
    Box,
    Chip,
    Paper,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useTranslation } from 'react-i18next';
import Constants from '../../../../../common/constants';

function CaptchaSettings() {
    const { t } = useTranslation();
    const siteKey = Constants.RECAPTCHA_SITE_KEY || '';

    return (
        <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 600 }}>
            <Stack direction='row' spacing={1.5} alignItems='center' sx={{ mb: 3 }}>
                <SecurityRoundedIcon color='primary' />
                <Typography variant='h6' sx={{ fontWeight: 700 }}>
                    {t('admin.captcha.title')}
                </Typography>
            </Stack>

            <Paper variant='outlined' sx={{ borderRadius: 3, p: 3 }}>
                <Stack spacing={2.5}>
                    <Alert severity='info' sx={{ borderRadius: 2 }}>
                        {t('admin.captcha.configViaYaml')}
                    </Alert>

                    <Stack direction='row' alignItems='center' spacing={1.5}>
                        <Typography sx={{ fontWeight: 600 }}>{t('admin.captcha.status')}:</Typography>
                        <Chip icon={<CheckCircleRoundedIcon />} label={t('admin.captcha.statusEnabled')} color='success' size='small' />
                    </Stack>

                    <TextField
                        label={t('admin.captcha.siteKey')}
                        value={siteKey || '—'}
                        fullWidth
                        InputProps={{ readOnly: true }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: 'action.hover' } }}
                    />
                </Stack>
            </Paper>
        </Box>
    );
}

export default CaptchaSettings;
